import React, { createContext, useCallback, useContext, useState } from 'react';
import { createPortal } from 'react-dom';

type ToastType = 'success' | 'error' | 'info';
interface Toast { id: string; message: string; type: ToastType; }
interface ToastContextValue { push(msg:string, type?:ToastType, ttlMs?:number): void; }

const ToastContext = createContext<ToastContextValue|undefined>(undefined);

export function ToastProvider({children}:{children:React.ReactNode}){
  const [toasts,setToasts] = useState<Toast[]>([]);
  const push = useCallback((message:string, type:ToastType='info', ttlMs=4000) => {
    const id = Math.random().toString(36).slice(2);
    setToasts(t => [...t,{id,message,type}]);
    setTimeout(()=> setToasts(t => t.filter(x=>x.id!==id)), ttlMs);
  },[]);
  return (
    <ToastContext.Provider value={{push}}>
      {children}
      {createPortal(<div className="fixed z-50 bottom-4 right-4 flex flex-col gap-2 w-72">
        {toasts.map(t => <ToastItem key={t.id} t={t} />)}
      </div>, document.body)}
    </ToastContext.Provider>
  );
}

function ToastItem({t}:{t:Toast}){
  const base = 'text-xs px-3 py-2 rounded shadow border flex items-start gap-2';
  const color = t.type==='success' ? 'bg-emerald-600/90 border-emerald-400/40 text-white' : t.type==='error' ? 'bg-red-600/90 border-red-400/40 text-white' : 'bg-slate-800/90 border-slate-600/40 text-slate-100';
  const icon = t.type==='success'? 'fa-circle-check' : t.type==='error'? 'fa-triangle-exclamation' : 'fa-circle-info';
  return (
    <div className={base + ' ' + color}>
      <i className={`fa-solid ${icon} mt-0.5 text-[13px]`}></i>
      <span className="leading-snug">{t.message}</span>
    </div>
  );
}

export function useToast(){
  const ctx = useContext(ToastContext);
  if(!ctx) throw new Error('useToast deve ser usado dentro de ToastProvider');
  return ctx;
}
